import * as types from '../mutation-types'
import { apiV2 } from '../api'
import Vue from 'vue'

const _isFalsy = (val) => _.isNil(val) || _.isEmpty(val) || val == 0 || val === false
const _isValid = (val) => !_isFalsy(val)

const requestCancel = {
  token: Vue.axios.CancelToken,
  source: null
}

const dashboardV2 = {
  namespaced: true,

  state: {
    validationRequests: [],
    sortParams: {
      orderBy: "created_at",
      sortedBy: "desc",
    },
    requestCancel,
  },

  mutations: {
    [types.DASHBOARD_VALIDATION_REQUESTS_RECEIVED](state, payload) {
      state.validationRequests = payload.data
    },

  },

  actions: {
    getValidationRequests({ commit }, params) {
      const queryParams = {
        ...params,
        filter: {
          ...(params.filter || {}), // Utilise la propriété existante `filter` ou un objet vide si elle n'existe pas
          is_parent: 1,
          status: "pending",        // Ajoute ou met à jour `status`
        },
        sort: "-created_at",        // Ajoute `sort` à l'objet principal
      }

      return apiV2.getValidationRequests(queryParams)
        .then((response) => commit(types.DASHBOARD_VALIDATION_REQUESTS_RECEIVED, response.data))
    }
  }
}

export default dashboardV2



// WEBPACK FOOTER //
// ./client/store/modules/dashboardV2.js